"use client";
import React from "react";

import { defaultLanguage } from "../../../constants/languages";
export default function Success({ config, language }) {
  const description =
    config.texts?.[language || defaultLanguage]?.[2]?.description || "";

  return (
    <>
      <div className="w-full flex justify-center items-center lg:min-h-[300px] border border-[#D2D2D2] rounded-md p-3 lg:p-0">
        <div className="w-full max-w-md  flex flex-col justify-center items-center gap-2">
          <div className="flex justify-center items-center w-full">
            {description && (
              <div className={`relative rounded-lg px-3`}>
                <p
                  className="text-sm text-center font-semibold m-0"
                  style={{
                    color: config.text_color || "#000",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: description,
                  }}
                ></p>
              </div>
            )}
          </div>
          <div className="w-10 h-10 rounded-full border-5 border-[#3E5FFA] mt-2 md:mt-5"></div>
        </div>
      </div>
    </>
  );
}
